export default "__VITE_ASSET__404bc951__"